<div class="validation-container">
  <div class="header">
    <h4>Validation des images produit</h4>
    <div class="header-actions">
      <div class="view-toggle">
        <button [class.active]="viewMode === 'desk'" (click)="viewMode = 'desk'">Desktop</button>
        <button [class.active]="viewMode === 'mob'" (click)="viewMode = 'mob'">Mobile</button>
      </div>
      <span class="badge" *ngIf="validations.length">{{ validations.length }} en attente</span>
    </div>
  </div>

  <div *ngIf="loading" class="loading">Chargement...</div>

  <div *ngIf="!loading && validations.length === 0" class="empty-state">
    <p>Aucune image en attente de validation.</p>
  </div>

  <div *ngIf="!loading && validations.length > 0">
    <div class="bulk-actions">
      <button class="btn btn-sm btn-outline" (click)="selectAll()">Tout selectionner</button>
      <button class="btn btn-sm btn-outline" (click)="deselectAll()" *ngIf="selectedIds.size > 0">Deselectionner</button>
      <button
        class="btn btn-sm btn-success"
        (click)="approveSelected()"
        *ngIf="selectedIds.size > 0"
      >
        Approuver la selection ({{ selectedIds.size }})
      </button>
    </div>

    <div class="validation-grid">
      <div
        *ngFor="let validation of validations"
        class="validation-card"
        [class.selected]="selectedIds.has(validation.id)"
        (click)="toggleSelection(validation.id)"
      >
        <div class="image-preview">
          <img [src]="getImageUrl(validation)" [alt]="'Produit ' + validation.product_id" />
        </div>
        <div class="card-info">
          <span class="product-id">Produit {{ validation.product_id }}</span>
          <span class="campaign-name">{{ validation.campaign_name }}</span>
          <span class="slot">Slot {{ validation.slot_index }}</span>
        </div>
        <div class="card-actions" (click)="$event.stopPropagation()">
          <button class="btn btn-sm btn-success" (click)="approveSingle(validation)">Approuver</button>
          <button class="btn btn-sm btn-danger" (click)="rejectSingle(validation)">Rejeter</button>
        </div>
      </div>
    </div>
  </div>
</div>
